import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import VideoFilter from "../Video/VideoFilter.jsx";
import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import FilteredChipNew from "src/components/FilteredChipNew";
import moment from "moment";
import { get_harmony_ring_information_api } from "src/DAL/Programme/Programme";
import RadialBarChart from "src/components/RadialBarChart.jsx";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer.js";
import { dd_date_format } from "src/utils/constant.js";
import GeneralCalendar from "src/components/GeneralComponents/GeneralCalendar.jsx";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const get_view_dates = (calendarValue) => {
  let tool = calendarValue;

  const startOfMonth = moment().startOf(tool);
  const daysToSubtract = startOfMonth.day() - 0;
  const previousSunday = startOfMonth.subtract(daysToSubtract, "days");
  let previousSundayDate = previousSunday.toDate();

  let add_days = 42;
  if (tool == "week") {
    add_days = 6;
  } else if (tool == "day") {
    add_days = 0;
  }

  let nextSaturday = startOfMonth.add(add_days, "days");
  let nextSaturdayDate = nextSaturday.toDate();
  if (tool == "day") {
    previousSundayDate = new Date();
    nextSaturdayDate = new Date();
  }

  return {
    start_date: previousSundayDate,
    end_date: nextSaturdayDate,
  };
};

const MemberChartInfo = () => {
  const classes = useStyles();
  const calendarRef = useRef();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [programmesData, setProgrammesData] = useState([]);
  const [harmonyRing, setHarmonyRing] = useState([]);
  const [currentDate, setCurrentDate] = useState(get_view_dates("month"));
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();
  const [workouts, setworkouts] = useState([]);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const getTodayDate = () => {
    const today = new Date();
    return today;
  };

  const getOneMonthAgoDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date;
  };

  const EMPTY_FILTER = {
    start: getOneMonthAgoDate(),
    end: getTodayDate(),
    filter_by_dates: false,
    comp_end_date: null,
    comp_start_date: null,
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);

  const handleSelectOther = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
    if (!filterData.filter_by_dates) {
      setFilterData((values) => ({
        ...values,
        ["comp_end_date"]: null,
        ["comp_start_date"]: null,
      }));
    }
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const getProgrammesList = async (filterData) => {
    setIsLoading(true);
    let postData = { ...filterData };
    let path = "";
    if (postData.start) {
      postData.start = moment(postData.start).format("YYYY-MM-DD");
    }
    if (postData.end) {
      postData.end = moment(postData.end).format("YYYY-MM-DD");
    }

    if (postData.filter_by_dates) {
      if (postData.comp_start_date) {
        postData.comp_start_date = moment(postData.comp_start_date).format(
          "YYYY-MM-DD",
        );
      }
      if (postData.comp_end_date) {
        postData.comp_end_date = moment(postData.comp_end_date).format(
          "YYYY-MM-DD",
        );
      }
      path = `&comp_start_date=${postData.comp_start_date}&comp_end_date=${postData.comp_end_date}&view=comp`;
    }

    handleCloseFilterDrawer();
    const result = await get_harmony_ring_information_api(
      params.CalId,
      params.id,
      postData.start,
      postData.end,
      path,
    );
    if (result.code === 200) {
      setProgrammesData(result?.harmony_ring_date || []);
      setHarmonyRing(result?.comp_harmony_ring || []);
      setworkouts(result?.uncompleted_workouts || []);
      let chipData = { ...filterData };

      if (chipData.start && chipData.end) {
        let date = `Start Date : ${dd_date_format(
          chipData.start,
        )} End Date :  ${dd_date_format(chipData.end)}`;
        chipData.date = {
          chip_label: date,
          chip_value: date,
        };
        delete chipData.start;
        delete chipData.end;
      }
      if (
        chipData.comp_start_date &&
        chipData.comp_end_date &&
        chipData.filter_by_dates
      ) {
        let comp_date = `Comparison Start Date : ${dd_date_format(
          chipData.comp_start_date,
        )} Comparison End Date :  ${dd_date_format(chipData.comp_end_date)}`;
        chipData.comp_date = {
          chip_label: comp_date,
          chip_value: comp_date,
        };
      }

      delete chipData.comp_start_date;
      delete chipData.comp_end_date;
      delete chipData.filter_by_dates;
      setUpdateFilterData(chipData);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const searchFunction = () => {
    if (!filterData.start || !filterData.end) {
      enqueueSnackbar("Please select date", { variant: "error" });
      return;
    }

    if (filterData.filter_by_dates) {
      if (!filterData.comp_start_date || !filterData.comp_end_date) {
        enqueueSnackbar("Please select comparison date", { variant: "error" });
        return;
      }
    }
    getProgrammesList(filterData);
  };

  const handleClearFilter = () => {
    getProgrammesList(EMPTY_FILTER);
    setFilterData(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
  };

  useEffect(() => {
    getProgrammesList(filterData);
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      <div clas sName="row">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <IconButton
              className="back-screen-button mb-0 me-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <div>
              <h2>Weekly Task Progress</h2>
              <p>
                By default, the graph shows member's task completion data from
                the past 7 days.
              </p>
            </div>
          </div>
          <button
            className="small-contained-button me-2 mt-1 mb-4"
            onClick={handleOpenFilterDrawer}
          >
            Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
          </button>
        </div>
        <div className="my-3">
          <FilteredChipNew
            data={updateFilterData}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onClear={handleClearFilter}
          />
        </div>
        <div className="col-12 mt-3">
          <RadialBarChart programmesData={programmesData} />
        </div>{" "}
        {updateFilterData?.comp_date && (
          <div className="col-12 mt-3">
            <h3>Performance Comparison</h3>
            <p className="text-muted">
              The following graph displays task completion percentages for the
              selected comparison date range.
            </p>
            <RadialBarChart programmesData={harmonyRing} />
          </div>
        )}
      </div>
      <div className="col-12 mt-3">
        <h3>Incomplete Tasks</h3>
        <p className="text-muted">
          The calendar below shows the member's incomplete tasks for the
          selected date range.
        </p>
      </div>
      <GeneralCalendar
        programWorkoutList={workouts}
        setCurrentDate={setCurrentDate}
        showAddEvent={true}
        time_zone={"asia/karachi"}
        currentDate={currentDate}
        isLoading={false}
        setIsLoading={() => {}}
        reloadList={() => {}}
        calendar_title={""}
        programme={{}}
        isPasted={false}
        setIsPasted={() => {}}
        difficultyLevel={[]}
        setDifficultyLevel={() => {}}
        calendarRef={calendarRef}
        goToToday={() => {}}
        is_show_only={true}
      />
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <VideoFilter
            filterData={filterData}
            handleSelectOther={handleSelectOther}
            searchFunction={searchFunction}
            handleClearFilter={handleClearFilter}
          />
        }
      />
    </div>
  );
};

export default MemberChartInfo;
